/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {TimepickerModule} from 'ngx-bootstrap/timepicker';
import template from './report-schedules-form.component.html';
import {compareById} from '../../common/util/object-id-comparison';
import {APP_SHARED} from '../../common/app-shared';
import {NextReportComponent} from '../../report-schedule/next-report.component';
import {ReportUrlComponent} from '../../report-schedule/report-url-component';

@Component({
  standalone: true,
  imports: [
    ...APP_SHARED,
    FormsModule,
    UIRouterModule,
    ButtonsModule,
    TimepickerModule,
    NextReportComponent,
    ReportUrlComponent
  ],
  selector: 'adn-report-schedules-form',
  template
})
export class ReportSchedulesFormComponent {
  @Input() reportSchedule: any;
  @Input() reportType: string;
  @Input() reportTemplates: any[] = [];
  @Input() lineItemReportTemplates: any[] = [];
  @Input() schedulePeriods: any[] = [];
  @Input() availableCurrencies: string[] = [];

  readonly weekDays = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
  readonly compareById = compareById;

  @Output() editRecipients = new EventEmitter<any>();
}
